// Chữ ký của toàn bộ đầu vào một lần chốt số. Mở kỳ ra thấy chữ ký khác cái đã lưu nghĩa là dữ liệu
// nguồn (thỏa thuận, hằng số, công, năng suất...) đã đổi sau lần chốt, số đang lưu không còn đúng.
import SHA256 from 'crypto-js/sha256';

// Sắp khóa object và đổi ngày về ISO để cùng dữ liệu luôn ra cùng một chuỗi, bất kể thứ tự đọc.
export function canonicalize(value) {
    if (value instanceof Date) return value.toISOString();
    if (Array.isArray(value)) return value.map(canonicalize);
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.keys(value)
            .filter((key) => key !== '_issues')
            .sort((left, right) => left.localeCompare(right))
            .map((key) => [key, canonicalize(value[key])]));
    }
    return value;
}

export function createInputHash(value) {
    return SHA256(JSON.stringify(canonicalize(value))).toString();
}
